export class RequestConstants {

    public static ConfigurationTypes = {
        RequestHeaders: "request_headers"
    };
}
